function normalizeBaseUrl(value) {
  if (!value || typeof value !== 'string') return '';
  return value.trim().replace(/\/$/, '');
}

export function getBackendBaseUrl() {
  const configured = normalizeBaseUrl(process.env.REACT_APP_BACKEND_URL);
  if (configured) return configured;

  if (typeof window !== 'undefined') {
    const { hostname, origin } = window.location;

    // Branch previews and production frontend domain should use dedicated API domain.
    if (hostname.endsWith('.pages.dev') || hostname === 'jobmatch.lynixai.com') {
      return 'https://api-jobmatch.lynixai.com';
    }

    return origin;
  }

  return '';
}

export function getApiBaseUrl() {
  const backendBase = getBackendBaseUrl();
  return backendBase ? `${backendBase}/api` : '/api';
}
